import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    if (url.includes('/public/resetpasswordprocess')) {
      return super.parse(url);
    }
    return super.parse(url.toLowerCase());
  }
}
